import { Typography } from 'antd';
import styled from 'styled-components';
const { Text } = Typography;

export const Logo = styled.div`
  /* width: 200px; */
  height: 66px;
`;

export const HeaderMainDiv = styled.div`
  display: flex;
  justify-content: space-between;
`;
export const HeaderMainDivLeft = styled.div``;
export const HeaderMainDivRight = styled.div``;
export const PageName = styled(Text)`
  font-weight: 700;
  font-size: 16;
  &:after {
    border-bottom: 0.125rem solid transparent;
    bottom: -6px;
    content: '';
    display: inline-block;
    left: 0;
    margin: auto;
    position: absolute;
    right: 0;
    width: 100%;
  }
`;
